module.exports = __webpack_public_path__ + "img/check-green-icon.41a3ac2b.svg";